module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('div', {
    staticClass: "container"
  }, [(_vm.flag == 'customer') ? _c('div', {
    staticClass: "loading",
    style: ({
      backgroundImage: ("url( " + _vm.url + ")"),
      backgroundSize: (_vm.width + " " + _vm.height)
    })
  }, [_c('section', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.times) + " 秒后进入")])]) : (_vm.flag == 'def') ? _c('div', {
    staticClass: "loading",
    style: ({
      backgroundImage: "url(/static/img/bg_mid.png)",
      backgroundSize: (_vm.width + " " + _vm.height)
    })
  }, [_c('section', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.times) + " 秒后进入")]), _vm._v(" "), _c('img', {
    staticClass: "gif",
    attrs: {
      "src": "/static/img/bg_top.gif",
      "width": "150",
      "alt": ""
    }
  })]) : _c('div', {
    staticClass: "loading"
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c6b76d0"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading/Loading.vue
// module id = 509
// module chunks = 1